import type { Components, Theme } from "@mui/material/styles";

export const MuiCssBaseline: Components<Theme>["MuiCssBaseline"] = {
  // css baseline is a special snowflake that references theme variables differently
  styleOverrides: (theme) => ({
    /*
      Some baselining necessary otherwise width + margin/padding calculation
      becaomes annoying. Look up what box-sizing does if you aren't familiar
    */
    html: {
      boxSizing: "border-box",
      // overscroll-behavior on html works in FF/Safari
      overscrollBehavior: "none",
    },

    body: {
      fontSize: "0.875rem",
      lineHeight: 1.43,
      letterSpacing: "0.01071em",
      margin: 0,
      minWidth: theme.spacing(theme.layout.SCREEN_BREAK_1),
      overflow: "auto",
      // overscroll-behavior on html works in Chromium
      overscrollBehavior: "none",
    },

    "*, *::before, *::after": {
      boxSizing: "inherit",
    },

    /* :target represents the element designated by the hash */
    ":target": {
      scrollMarginTop: theme.spacing(theme.layout.BODY_MARGIN),

      [`@media (min-height: ${theme.spacing(theme.layout.SCREEN_BREAK_1)})`]: {
        scrollMarginTop: theme.spacing(
          theme.layout.NAVBAR_HEIGHT +
            theme.layout.PROJECT_TOOLBAR_HEIGHT +
            theme.layout.BODY_MARGIN
        ),
      },
    },

    "#citrine-root": {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      width: "100%",

      ".notistack-SnackbarContainer": {
        zIndex: theme.zIndex.snackbar,
      },
    },

    "#beacon-container .BeaconFabButtonFrame": {
      bottom: theme.spacing(theme.layout.BODY_MARGIN / 2),
      right: theme.spacing(theme.layout.BODY_MARGIN / 2),
      transform: "scale(calc(2 / 3)) !important",
      transformOrigin: "bottom right",

      [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_2)})`]: {
        bottom: theme.spacing(theme.layout.BODY_MARGIN),
      },
      [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_3)})`]: {
        right: theme.spacing(theme.layout.BODY_MARGIN),
      },
      [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_4)})`]: {
        right: theme.spacing(2 * theme.layout.BODY_MARGIN),
      },
    },

    "#beacon-container .BeaconContainer": {
      bottom: theme.spacing(2 * theme.layout.BODY_MARGIN),
      height: "calc(100% - 100px)",
      right: theme.spacing(theme.layout.BODY_MARGIN / 2),

      [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_2)})`]: {
        bottom: theme.spacing(2.5 * theme.layout.BODY_MARGIN),
        height: `calc(100% - ${theme.spacing(3 * theme.layout.BODY_MARGIN)})`,
      },
      [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_3)})`]: {
        right: theme.spacing(theme.layout.BODY_MARGIN),
      },
      [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_4)})`]: {
        right: theme.spacing(2 * theme.layout.BODY_MARGIN),
      },
    },

    ".sentry-error-embed-wrapper": {
      "&&": {
        zIndex: 9999,
      },
    },
  }),
};
